<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Western &amp; Atlantic Railroad</title>
<link href="template.css" rel="stylesheet" type="text/css"/>
<p class="title-head">C<span class="small">ONTENTS</span></p>
<table>
<colgroup>
<col width="40px"/>
<col width="350px"/>
</colgroup>
<tbody>
<tr>
<td colspan="2"><a href="#/Acknowledgments#Ack">Acknowledgments</a></td>
</tr>
<tr>
<td colspan="2"><a href="#/Introduction#Intro">Introduction</a></td>
</tr>
<tr>
<td><a href="#/Chapter01#C1">1.</a></td>
<td><a href="#/Chapter01#C1">Calm before the Storm</a></td>
</tr>
<tr>
<td><span href="#/Chapter02#C2" title="Link target outside of Sample">2.</span></td>
<td><span href="#/Chapter02#C2" title="Link target outside of Sample">The Civil War</span></td>
</tr>
<tr>
<td><span href="#/Chapter03#C3" title="Link target outside of Sample">3.</span></td>
<td><span href="#/Chapter03#C3" title="Link target outside of Sample">Rebuilding the Road</span></td>
</tr>
<tr>
<td><span href="#/Chapter04#C4" title="Link target outside of Sample">4.</span></td>
<td><span href="#/Chapter04#C4" title="Link target outside of Sample">Dawn of the 20th Century</span></td>
</tr>
<tr>
<td><span href="#/Chapter05#C5" title="Link target outside of Sample">5.</span></td>
<td><span href="#/Chapter05#C5" title="Link target outside of Sample">The Diesel Era</span></td>
</tr>
<tr>
<td><span href="#/Chapter06#C6" title="Link target outside of Sample">6.</span></td>
<td><span href="#/Chapter06#C6" title="Link target outside of Sample">The Modern Road</span></td>
</tr>
<tr>
<td><span href="#/Chapter07#C7" title="Link target outside of Sample">7.</span></td>
<td><span href="#/Chapter07#C7" title="Link target outside of Sample">Preserving the Western &amp; Atlantic</span></td>
</tr>
<tr>
<td colspan="2"><span href="#/Bibliography#Bib" title="Link target outside of Sample">Bibliography</span></td>
</tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?8e7af1ce